import {
  Avatar,
  Box,
  Divider,
  ListItemIcon,
  Menu,
  MenuItem,
} from "@mui/material";
import { Logout } from "@mui/icons-material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import CustomConfirmation from "../customCpnfirmations/CustomConfirmation";
import { VpnKey } from "@mui/icons-material";
import { useAdminContext } from "../../../hooks/UseAdminContext";
import { s3baseUri } from "../../../config/config";
import PersonIcon from "@mui/icons-material/Person";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import UserIcon from "../../assets/images/user.png";
import LogoutDialog from "../../dialogs/LogoutDialog";

export default function Accountmenu({ anchorEl, open, handleClose }) {
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const navigate = useNavigate();
  const {
    resetContext,
    userInfo,
    hasUnsavedChanges,
    setActionToRunAfterLeavingUnsavedPage,
    setShowUnsavedDialog
  } = useAdminContext();

  const handleNavigation = (route) => {
    handleClose();
    if (hasUnsavedChanges) {
      setActionToRunAfterLeavingUnsavedPage(() => () => navigate(route));
      setShowUnsavedDialog(true);
    } else {
      navigate(route);
    }
  };

  const handleProfile = () => {
    handleNavigation("/edit-profile");
  };

  const handleLogout = () => {
    setLogoutDialogOpen(false);
    navigate("/");
    resetContext();
    localStorage.clear();
    enqueueSnackbar("Logout successfully.", { variant: "success" });
  };

  const handleSupport = () => {
    handleNavigation("/support");
  };

  return (
    <>

      <LogoutDialog
        open={logoutDialogOpen}
        setOpen={setLogoutDialogOpen}
        handleAgree={handleLogout}
      />

      <Menu
        anchorEl={anchorEl}
        open={open}
        MenuListProps={{
          autoFocusItem: false,
        }}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            mt: 1.5,
            borderRadius: "10px",
            minWidth: "220px",
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
      >
        {localStorage?.getItem("code-verified") && (
          <>
            <MenuItem>
              <Avatar
                sx={{ mr: 1 }}
                src={userInfo?.profile_image ? s3baseUri + userInfo.profile_image : ""}
              >
                {!userInfo?.profile_image &&
                  userInfo?.name
                    ?.split(" ")
                    .map((n) => n[0])
                    .slice(0, 2)
                    .join("")}
              </Avatar>
              <Box>
                <p className="name_popup">{userInfo?.name}</p>
                <p className="text_truncate">{userInfo?.user_info?.email}</p>
              </Box>
            </MenuItem>
            <Divider />
          </>
        )}
        <MenuItem onClick={handleSupport}>
          <ListItemIcon>
            <SupportAgentIcon fontSize="small" style={{ color: "#15978a" }} />
          </ListItemIcon>
          Contact Support
        </MenuItem>{" "}
        {localStorage?.getItem("code-verified") && (
          <>
            <MenuItem onClick={handleProfile}>
              <ListItemIcon>
                <PersonIcon fontSize="small" style={{ color: "#15978a" }} />
              </ListItemIcon>
              Edit Profile
            </MenuItem>{" "}
            <MenuItem
              onClick={() => {
                handleNavigation("/change-password");
              }}
            >
              <ListItemIcon>
                <VpnKey fontSize="small" style={{ color: "#15978a" }} />
              </ListItemIcon>
              Change Password
            </MenuItem>
            <Divider />
            <MenuItem
              sx={{ color: "#000" }}
              onClick={() => {
                handleClose();
                if (hasUnsavedChanges) {
                  setActionToRunAfterLeavingUnsavedPage(() => () => setLogoutDialogOpen(true));
                  setShowUnsavedDialog(true);
                } else {
                  setLogoutDialogOpen(true);
                }
              }}
            >
              <ListItemIcon>
                <Logout fontSize="small" sx={{ color: "#15978a" }} />
              </ListItemIcon>
              Log Out
            </MenuItem>
          </>
        )}
      </Menu>
    </>
  );
}
